import CardSystem from '../CardSystem';
import Renderable from '../../../Component/Renderable';
import GameObject from '../../../GameObject/GameObject';
import CardAnimationTask from '../../../Utility/Task/CardAnimationTask';
import Animator from '../../../Prototype/Animator';
import { UIEvent } from '../../UI/BaseUISystem';
import { ICardStateTaskData } from '../../../State/Card/ICardState';
import BaseCard from 'Prototype/Level/Card/BaseCard';

export default function BullsEyeCardAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData
): void {
    if (!taskData.cards || taskData.cards.length <= 0) return;
    system.scene.emit(UIEvent.DISABLE_INTERACTIVITY, false);

    const cards: BaseCard[] = [];
    taskData.cards.forEach(cardID => {
        const card = system.getCardByID(cardID);
        card.getComponent(Renderable).visible = true;
        cards.push(card);
    });
    const bullsEyeAnimator = GameObject.Instantiate(Animator);
    system.animator.addChild(bullsEyeAnimator);

    system.taskQueue.queueNext(
        new CardAnimationTask(
            taskData,
            system,
            'BoosterBullsEye',
            bullsEyeAnimator,
            {
                cards,
                score: taskData.score,
            }
        )
    );
}
